<template>
  <div class="cnc-checkbox-group" :class="size === 'medium' ? 'medium' : 'small' ">
    <div class="fragment-head" :class="{ 'disabled' : disabled }">
      <div v-if="title" class="txt-title">{{ title }}</div>
      <div v-if="rightIcon && rightIcon.name">
        <SvgIcon v-if="rightIcon.type === 'svg'" :name="rightIcon.name"/>
        <Icon v-else :name="rightIcon.name"/>
      </div>
    </div>
    <div v-if="desc" class="txt-checkbox-desc" :class="{ 'disabled' : disabled }">{{ desc }}</div>
    <div :class="orientation === 'horizontal' ? 'cnc-checkbox-group-horizontal' : 'cnc-checkbox-group-vertical' ">
      <CncCheckbox v-if="hasIndeterminate" v-model="checkAll" v-bind="indeterminateProps" @change="onChangeAll">Check all</CncCheckbox>
      <el-checkbox-group v-model="val" @change="onChange">
        <CncCheckbox v-for="(item, index) in choices" :key="index" :label="item.label || item.id" :disabled="disabled || item.disabled" :isError="isError || item.isError" :size="size" :data-qa="$fn.formatDataQa(index + 1, 'checkbox')">{{ isTranslate ? $t(item.name) : item.name }}</CncCheckbox>
      </el-checkbox-group>
    </div>
    <div v-if="isError" class="txt-checkbox-error">{{ errMessage }}</div>
  </div>
</template>

<script>
  export default {
    components: {
      Icon: () => import('./Icon.vue'),
    },
    props: {
      choices: { type: Array, default: () => [] },
      value: { type: Array, default: () => [] },
      label: { type: [String, Number] },
      hasIndeterminate: { type: Boolean },
      size: { type: String, default: 'medium' },
      orientation: { type: String, default: 'horizontal' },
      rightIcon: { type: Object },
      title: { type: String },
      desc: { type: String },
      disabled: { type: Boolean },
      isError: { type: Boolean },
      errMessage: { type: String },
      isTranslate: { type: Boolean }
    },
    data () {
      return {
        val: this.value,
        checkAll: false,
        isIndeterminate: true
      }
    },
    computed: {
      indeterminateProps () {
        return {
          isIndeterminate: this.isIndeterminate,
          size: this.size, 
          disabled: this.disabled,
          isError: this.isError 
        }
      }
    },
    watch: {
      'value' (val, oldVal) {
          this.val = val
        },
      'val' (val) {
        this.$emit('update:value', val)
      }
    },
    methods: {
      onChangeAll (val) {
        this.val = val ? this.choices.map( e => e.label || e.id ) : []
        this.isIndeterminate = false
        this.$emit('onChangeAll', val)
      },
      onChange (value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.choices.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.choices.length
        this.$emit('onChange', value)
      }
    }
  }
</script>


<style lang="scss">
.cnc-checkbox-group {
  .fragment-head {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;

    i {
      color: $color-cool-grey-500;
    }

    &.disabled {
      .txt-title {
        color: $color-cool-grey-300;
      }
    }
  }

  .txt-checkbox-desc {
    color: $color-cool-grey-500;
    font-size: $font-size-sm;
    cursor: default;
    white-space: pre-wrap;
    word-wrap: break-word;

    &.disabled {
      color: $color-cool-grey-300;
    }
  }

  .txt-checkbox-error {
    color: $color-semanticRed-500;
    font-size: $font-size-sm;
    cursor: default;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .cnc-checkbox-group-vertical {
    display: flex;
    flex-direction: column;

    .el-checkbox-group {
      display: flex;
      flex-direction: column;
    }
  }

  .cnc-checkbox-group-horizontal {
    display: flex;
    gap: 24px;

    .el-checkbox-group {
      display: flex;
      gap: 24px;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  &.small {
    .txt-title {
      font: $font-style-body-md-reg;
    }

    .txt-checkbox-desc {
      font: $font-style-body-sm-reg;
    }

    .txt-checkbox-error {
      font: $font-style-body-sm-reg;
    }

    .fragment-head { 
      i {
        font-size: $font-size-md !important;
      }
    }

    .txt-checkbox-desc {
      font-size: $font-size-xs;
      margin-bottom: 8px;
    }

    .el-checkbox-group {
      column-gap: 16px;
      row-gap: 8px;
    }
  }

  &.medium {
    .txt-title {
      font: $font-style-body-lg-reg;
    }

    .txt-checkbox-desc {
      font: $font-style-body-md-reg;
    }

    .txt-checkbox-error {
      font: $font-style-body-md-reg;
    }

    .fragment-head {
      i { 
        font-size: 20px !important;
      }
    }

    .txt-checkbox-desc {
      font-size: $font-size-sm;
      margin-bottom: 12px;
    }

    .el-checkbox-group {
      column-gap: 24px;
      row-gap: 12px;
    }
  }
}
</style>